// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.TenantLookup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from 'react';
import * as _ from 'lodash/fp';
import connect from 'share/enhancers/Izenda.Connect';
import SelectTenantPopup from 'share/components/controls/SelectTenantPopup/Izenda.SelectTenantPopup';
import Validator from 'share/components/hoc/Izenda.Validator';
import Select from 'share/components/controls/multiSelectBox/Izenda.Select';

const ValidatorSelect = Validator()(Select);

@connect()
export default class TenantLookUp extends Component {

  openTenantPopup = () => {
    const props = this.props;
    // The item ids which will be checked by default
    const selectedItems = props.value;

    props.openPopup(SelectTenantPopup, {
      selectedItems: _.map('id', selectedItems || [])
    })
    .then(result => {
      props.onChangeFromPopup(result);
    })
  };

  render() {
    const props = this.props;
    const { localization } = props;


    return (
      <div className="izenda-Recipient-Container">
        <ValidatorSelect
          textboxMode
          multi
          hiddenMenu
          searchable={false}
          clearable={false}
          disabled={props.disabled || props.readOnly}
          options={props.data}
          valueKey={props.valueField}
          labelKey={props.textField}
          value={props.value}
          field={props.field}
          group={props.group}
          onChange={props.onChange}
          validations={props.validations}
        />
        <a>
          <span
            onClick={!props.readOnly && this.openTenantPopup}
            className="icon-plus"
            title={localization.getText('SELECT_TENANT')}
          />
        </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Tenant/Izenda.TenantLookUp.js